import keyMirror from 'keymirror'

export const UserTypes = keyMirror({
  USER: null,
  END_USER: null,
  LEAD: null,
})

export const UserTypeNumeral = Object.freeze({
  USER: 1,
  END_USER: 2,
  LEAD: 4,
})



// WEBPACK FOOTER //
// ./src/scripts/utils/UserTypes.js